module.exports = __webpack_public_path__ + "img/Aurora_F_sleeve.571cab45.svg";